module.exports = __webpack_public_path__ + "img/asking.5655fd74.svg";